export const DEFAULT_CALLBACK_CONTENT = {
  buttonText: 'Перезвоните мне',
  modalTitle: 'Оставьте номер телефона, и мы\u000Aперезвоним вам в течение минуты',
  modalButtonText: 'Перезвоните мне',
  successTitle: 'Оставьте номер телефона, и мы\u000Aперезвоним вам в течение минуты',
};
